"use strict";

import angular from "angular";
import ForgottenController from "./forgotten.controller";

export default angular
  .module("dalApp.forgotten", [])
  .controller("ForgottenController", ForgottenController).name;



// WEBPACK FOOTER //
// ./client/app/account/forgotten/index.js